// extracted by mini-css-extract-plugin
module.exports = {"ctn":"judge_ctn__2jE5A","contentBox":"judge_contentBox__2_oC0","img":"judge_img__oEt9D"};